import React from 'react';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import CheckIcon from '@mui/icons-material/CheckRounded';
import MediaPickersConstants from '../MediaPickersConstants';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const StockOrientationSelect = ({ classes, mediaOrientation, setStockMediaOrientation, onOrientationChange }) => {
    const imageOrientations = MediaPickersConstants.STOCK_MEDIA_ORIENTATION;

    const onChange = (orientation) => {
        setStockMediaOrientation(orientation);
        onOrientationChange(orientation);
    }

    return (
        <>
            <MenuItem   
                onClick={() => onChange(imageOrientations.ALL_ORIENTATIONS)}
                selected={mediaOrientation === imageOrientations.ALL_ORIENTATIONS}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{ visibility: mediaOrientation === imageOrientations.ALL_ORIENTATIONS ? null : 'hidden' }} />
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    All Orientations
                </ListItemText>
            </MenuItem>
            <MenuItem
                onClick={() => onChange(imageOrientations.HORISONTAL)}
                selected={mediaOrientation === imageOrientations.HORISONTAL}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{ visibility: mediaOrientation === imageOrientations.HORISONTAL ? null : 'hidden' }} />
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    Horizontal
                </ListItemText>
            </MenuItem>
            <MenuItem
                onClick={() => onChange(imageOrientations.VERTICAL)}
                selected={mediaOrientation === imageOrientations.VERTICAL}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{ visibility: mediaOrientation === imageOrientations.VERTICAL ? null : 'hidden' }} />
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    Vertical
                </ListItemText>
            </MenuItem>
            <MenuItem
                onClick={() => onChange(imageOrientations.SQUARE)}
                selected={mediaOrientation === imageOrientations.SQUARE}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{ visibility: mediaOrientation === imageOrientations.SQUARE ? null : 'hidden' }} />
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    Square
                </ListItemText>
            </MenuItem>
        </>
    );
};

export default withStyles(StockOrientationSelect, styles);